'use strict';

angular.module('utils', []).factory('OCPhotoUtil', function($http, $q, ClinicConfig) {
  var self = {
    // Convert a dataURI to a Blob.
    dataURIToBlob: function(dataURI) {
      var binary = window.atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], {
        type: mimeString,
      });
    },

    // Upload a photo dataURI to a resource URI.
    uploadPhotoDataURI: function(resourceURI, dataURI) {
      return this.uploadPhoto(resourceURI, this.dataURIToBlob(dataURI));
    },

    // Upload a photo blob to a resource URI.
    uploadPhoto: function(resourceURI, blob) {
      var fd = new FormData();
      fd.append('photo', blob);
      return $http.post(resourceURI, fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined,
        },
      });
    },

    // Get a size object for a dataURI representing a photo.
    photoSizeDataURI: function(dataURI) {
      var deferred = $q.defer();
      var img = new Image();
      img.onload = function() {
        deferred.resolve({
          width: img.width,
          height: img.height,
        });
      };
      img.src = dataURI;
      return deferred.promise;
    },

    readAsDataURI: function(file) {
      var deferred = $q.defer();
      var reader = new FileReader();
      reader.onload = (function() {
        return function(e) {
          deferred.resolve(e.target.result);
        };
      }(file));
      reader.readAsDataURL(file);
      return deferred.promise;
    },

    getS3ImageUrl: function(imageData, size) {
      if (!_.get(imageData, 'name')) {
        return;
      }
      size = size || 'original';
      return ClinicConfig.S3_BUCKET_URL + imageData.name + '-' + size + '.' + imageData.extension;
    },
    insurancePhotoUrl: function(imageData, size) {
      if (!_.get(imageData, 'name')) {
        return;
      }
      size = size || 'original';
      var preUrl = ClinicConfig.S3_BUCKET_URL_WITH_DEV || ClinicConfig.S3_BUCKET_URL;
      return preUrl + imageData.name + '-' + size + '.' + imageData.extension;
    },

    // Get a path to the primary photo (or default image) for a model.
    primaryPhotoForModel: function(modelType, primaryPhoto) {
      return self.getS3ImageUrl(primaryPhoto, '200x200') || '/img/' + modelType + '-profile.png';
    },
  };

  return self;
});
